import {Emitter} from '@wonderlandengine/api';

/**
 * The UpdateFrameContext interface is for components and hooks that need to listen to the
 * update cycle. Because the React components do no know anything about the Wonderland
 * components behind them but need the update cycle sometimes.
 */
export interface UpdateFrameContext {
    updateEvent: Emitter<[number]>;
    relativeScale: number[];
}

/**
 * Implementation of the UpdateFrameContext interface that is used by the main component
 * to trigger updates.
 */
export class UpdateFrameContextInt implements UpdateFrameContext {
    updateEvent: Emitter<[number]> = new Emitter<[number]>();
    relativeScale: number[];
    triggerUpdate(dt: number) {
        this.updateEvent.notify(dt);
    }
}
